import React, { useMemo } from 'react';
import Modal from '../../../../Components/Modal';
import Form, { Actions, Radio } from '../../../../Components/Form';
import Money from '../../../../Components/Formatting/Money';
import { payoutFees, useBalance } from '../../../../Data/Balance';

const thresholds = [5000, 10000, 25000, 50000, 100000, 200000, 500000];

const fees = (threshold) => {
    const fee = payoutFees(threshold);
    if (fee === 0) {
        return 'No fees';
    }
    return `${fee}p per payout`;
}

const PayoutThreshold = ({isOpen, setIsOpen, onChanged}) => {
    return <Modal title="Payout threshold" isOpen={isOpen} setIsOpen={setIsOpen} dismissible>
        {isOpen && <Inner {...{onChanged}} />}
    </Modal>
}

const Inner = ({onChanged}) => {
    const {balance, changePayoutThreshold} = useBalance(false);

    const thresholdOptions = useMemo(() => {
        return thresholds.map(threshold => ({
            label: <>
                <Money pence={threshold} hidePence />
                &nbsp;
                <span className="text-muted text-sm">({fees(threshold)})</span>
            </>,
            value: threshold,
        }))
    }, []);

    const handleChange = async (data) => {
        await changePayoutThreshold(data.payoutThreshold);
        onChanged && onChanged();
    }

    return <Form waitForData data={balance} onSubmit={handleChange} closeModalOnSubmit>
        <p>Once your payable balance reaches this amount we'll automatically start a payout to your bank account.</p>
        <Radio name="payoutThreshold"
            label="Payout Threshold"
            layout="List"
            options={thresholdOptions}
        />
        <Actions submit={{label: 'Save'}} cancel />
    </Form>
}

export default PayoutThreshold;
